import { render, staticRenderFns } from "./EyeClose.vue?vue&type=template&id=263ed63e&"
import script from "./EyeClose.vue?vue&type=script&lang=js&"
export * from "./EyeClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports